import RequestService from "../../services/RequestService";
import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import Professional from '../../models/Professional'


export default class InterestReasonsDataForm implements FormBase {

    Reason: FormFieldBase;
    HowToContribute: FormFieldBase;

    constructor(Reason: string, HowToContribute: string) {
        this.Reason = new FormFieldBase(Reason, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.HowToContribute = new FormFieldBase(HowToContribute, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }


    static NewInstance(): InterestReasonsDataForm {
        return new InterestReasonsDataForm("", "");
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return RequestService.postInterestReasons(dataJson, Professional.Id);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, insira os campos obrigatórios."
        } else {
            return "";
        }
    }


    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Reason":
                return this.Reason;
            case "HowToContribute":
                return this.HowToContribute;
            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "ProfessionalId": 0,
            "reason": this.Reason.Value,
            "howToContribute": this.HowToContribute.Value,
        }
    }
}